import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { toastSweetAlert } from '../Helpers/ToastSweetAlert'
import Box from '../Global/Box'
import { GET_ONE_BLOG_POST } from '../../graphql/BlogPosts/blogPosts'

export const BlogPostPreview = ({ id }) => {
  //STATES:
  const [data, setData] = useState(null)

  //QUERIES:
  const {
    data: dataResp,
    loading,
    error,
  } = useQuery(GET_ONE_BLOG_POST, {
    variables: {
      id: parseInt(id),
    },
  })

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (id) {
        if (error) {
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }
        if (dataResp !== undefined && dataResp !== null) {
          const data = dataResp.getOneBlogPost
          setData(data)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dataResp, error, loading])

  return (
    <>
      <Box
        withCard={false}
        content={
          <>
            <div className="row mt-1 mb-5">
              <div className="mb-3 col-12 col-sm-4">
                <h1>
                  <b>Titulo:</b> {data?.title}
                </h1>
              </div>
              <div className="mb-3 mt-2 col-12">
                <b>Contenido resumen:</b> {data?.summary_content}
              </div>
              <div className="mb-3 mt-2 col-12">
                <b>Contenido:</b> {data?.content}
              </div>
              {data?.image_file_url && data?.image_file_id && (
                <div className="col-12 col-sm-6 mb-3 mt-2 ">
                  <img src={data.image_file_url} width={'100%'} alt="Imagen" />
                </div>
              )}
              {data?.external_link && (
                <div className="mb-3 mt-3 col-12">
                  <a
                    className="btn btn-primary"
                    href={data.external_link}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {data?.external_link_label ?? 'Ver mas'}
                  </a>
                </div>
              )}
            </div>
          </>
        }
      />
    </>
  )
}
export default BlogPostPreview
